// components/Tips/TipSequence.js
import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useTips } from './TipContext';
import Tip from './Tip';

const TipSequence = ({ tips, autoStart = true }) => { 
    const history = useHistory()

    const { completedTips, activeTip, setActiveTip, hideTips } = useTips();

    useEffect(() => {
        if (autoStart && !activeTip && !hideTips) {
            const nextTip = tips.find(tip => !completedTips[tip.id]);
            if (nextTip) {
                setActiveTip(nextTip.id);
            }
        } else {
            
        }
    }, [autoStart, completedTips, tips, activeTip, hideTips]);

    const handleTipComplete = (currentTip) => {

        const currentIndex = tips.findIndex(tip => tip.id === currentTip.id);
        const nextTip = tips[currentIndex + 1];
        if (nextTip && !completedTips[nextTip.id]) {
            setActiveTip(nextTip.id);
        }

        if (currentTip.targetUrl) {
            history.push({ 
                pathname: currentTip.targetUrl,
                state: {
                    fromTip: true
                }
            });
        }

        if (currentTip.onComplete) {
            currentTip.onComplete();
        }
    };

    return (
        <>
            {tips.map(tip => (
                <Tip
                    key={tip.id}
                    {...tip}
                    onComplete={() => handleTipComplete(tip)}
                />
            ))}
        </>
    );
};

export default TipSequence;
